import AiImg from '@op/assets/svg/icon-ai.svg';
import kolDefaultIcon from '@op/assets/svg/kol-default.svg';
import videoDefaultImg from '@op/assets/svg/video-cover.svg';
import PCGameDefaultImg from '@op/assets/svg/pc-game-default.svg';

export const DefaultImg = {
  AI: AiImg,
  KOL: kolDefaultIcon,
  VIDEO: videoDefaultImg,
  GAME: PCGameDefaultImg,
};
